const environments = {

  staging: {
    url: "https://sdeiaiml.com:8004/",
    chatbotUrl: "https://sdeiaiml.com:9024"
  },

  local: {
    url: "http://localhost:8003/",
    chatbotUrl: "https://sdeiaiml.com:9024"
  },
  prod: {
    url: "https://api.hoaverified.com/",
    chatbotUrl: "https://hoa-ai.hoaverified.com"
  }
};
export default environments;
